import { render, staticRenderFns } from "./WorkContract.vue?vue&type=template&id=383fb86a&"
import script from "./WorkContract.vue?vue&type=script&lang=js&"
export * from "./WorkContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports